/**
 * PriceDisplay Component
 * 
 * Displays the calculated booking price with an optional tax disclaimer.
 */

import type { PriceDisplayProps } from './types';

export function PriceDisplay({ 
  price, 
  showTaxDisclaimer = true,
  className = '' 
}: PriceDisplayProps) {
  // Format price as currency
  const formattedPrice = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(price);

  return (
    <div 
    className={className}
    data-testid="booking-summary-price-display">
      {/* Price */}
      <div className="flex flex-col">
        <div className="flex items-baseline gap-2">
          <span className="sr-only">Total price:</span>
          <span 
            className="text-2xl font-bold text-fg-primary"
            aria-label={`${price} dollars`}
            data-testid="booking-summary-price-value"
          >
            {formattedPrice}
          </span>
        </div>
        
        {/* Tax Disclaimer */}
        {showTaxDisclaimer && (
          <p className="mt-1 text-sm text-fg-input">
            Taxes not included
          </p>
        )}
      </div>
    </div>
  );
}
